import {
    DL_GET_PUBLISHED_CATEGORIES,
    DL_GET_PUBLISHED_CATEGORIES_ERROR,

    GET_DL_MANUFACTURERS,
    GET_DL_MANUFACTURERS_ERROR,
} from "../actions/types";

const initialState = {
    publishedCategoriesDL: [],
    allManufacturersDL: [],
    isLoading: true,
    success: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {

        case DL_GET_PUBLISHED_CATEGORIES:
            return {
                ...state,
                publishedCategoriesDL: payload,
                isLoading: false,
                success: true,
            };

        case GET_DL_MANUFACTURERS:
            return {
                ...state,
                allManufacturersDL: payload,
                isLoading: false,
                success: true,
            };

        case DL_GET_PUBLISHED_CATEGORIES_ERROR:
        case GET_DL_MANUFACTURERS_ERROR:
            return {
                ...state,
                isLoading: false,
                success: true,
            };

        default:
            return state;
    }
}
